import { render } from "./VerticalNavMenuGroup.vue?vue&type=template&id=6409ba98"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
script.render = render

export default script